/**
 * Send SMS Actor
 *
 * Sends OTP verification code via SMS
 * Uses POST /otp/request-by-userid endpoint via kiosk server action
 */

import type { LanguageCodeWithFrench } from "@/app/common/constants";
import { requestAndSendOTPMessage } from "@/app/directories/kiosk/server-actions/otp-actions";
import { fromPromise } from "xstate";

export interface SendSMSInput {
  userId: string;
  phoneNumber: string;
  orgName: string;
}

export interface SendSMSOutput {
  otpTime: string;
  userId: string;
}

/**
 * Send SMS Actor Implementation
 */
export const sendSMSActor = fromPromise<SendSMSOutput, SendSMSInput>(
  async ({ input }) => {
    const { userId, phoneNumber, orgName } = input;

    console.log("[sendSMSActor] Sending OTP:", {
      userId,
      phoneNumber: `${phoneNumber.slice(0, 5)}***`,
      orgName,
    });

    try {
      // Send OTP using kiosk server action
      // Signature: (userId, org, phone, email, language)
      const result = await requestAndSendOTPMessage(
        userId,
        orgName,
        phoneNumber,
        "", // email (empty string as per kiosk pattern)
        "en" as LanguageCodeWithFrench,
      );

      console.log("[sendSMSActor] OTP request result:", {
        success: result.success,
        userId: result.success ? result.data.userId : undefined,
      });

      // Handle ActionResult response structure
      if (!result.success) {
        throw new Error(result.error.message || "Failed to send OTP");
      }

      return {
        otpTime: result.data.time,
        userId: result.data.userId,
      };
    } catch (error) {
      console.error("[sendSMSActor] Error sending OTP:", error);
      throw new Error(
        error instanceof Error ? error.message : "Failed to send OTP",
      );
    }
  },
);
